import { Component, EventEmitter, Output, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'bodyanalytics-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css'],
  imports: [ReactiveFormsModule],
})
export class LoginFormComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  @Output() submitFormEvent = new EventEmitter<any>();

  public loginForm = new FormGroup({
    emailAddress: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
  });

  public login(): void {
    this.submitFormEvent.emit({
      emailAddress: this.loginForm.value.emailAddress as string,
      password: this.loginForm.value.password as string,
    });
  }
}
